<template>
    <div>
        <div class="partnerCard__card">
            <div class="partnerCard">
                <div class="logo__container">
                    <dynamic-image
                        :image-name="image"
                        class="lazyLoad logo__image"
                    />
                </div>
                <div class="content">
                    <p class="content__partnerName">{{ partnerName }}</p>
                    <p class="content__description">{{ description }}</p>
                    <a
                        class="content__link"
                        :href="href"
                        target="_blank"
                        rel="noopener"
                    >
                        {{ `mehr über ${partnerName}` }}
                    </a>
                </div>
            </div>
        </div>
        <a
            :href="href"
            target="_blank"
            class="partnerCard__href"
            rel="noopener"
        >
            <div v-ripple class="partnerCard">
                <div class="logo__container">
                    <dynamic-image
                        :image-name="image"
                        class="lazyLoad logo__image"
                    />
                </div>
                <div class="content">
                    <p class="content__partnerName">{{ partnerName }}</p>
                </div>
            </div>
        </a>
    </div>
</template>

<script>
import DynamicImage from '@/components/atoms/image/dynamicImage.vue'

export default {
    name: 'PartnerCard',
    components: {
        DynamicImage,
    },
    props: {
        image: {
            type: String,
            required: true,
        },
        partnerName: {
            type: String,
            required: true,
        },
        description: {
            type: String,
            required: true,
        },
        href: {
            type: String,
            required: true,
        },
    },
}
</script>

<style lang="stylus" scoped>
.partnerCard {
    border-radius: $cs-border-radius;
    overflow: hidden;
    box-shadow: $cs-box-shadow-card;
    transition: box-shadow .3s ease-in-out;
    text-align: left;
    color: $cs-slate-300;

    &:hover {
        box-shadow: $cs-box-shadow-card-hover;
    }
}

.partnerCard__card {
    display: none;

    @media $display-breakpoints.md-and-up {
        display: block;
    }
}

.partnerCard__href {
    text-decoration: none;
    color: $cs-slate-400;

    @media $display-breakpoints.md-and-up {
        display: none;
    }
}

.logo__container {
    background-color: $cs-white;
    padding: $cs-space 42px;
}

.logo__image {
    height: 100%;
    width: 100%;
    pointer-events: none;
}

.content {
    background-color: $cs-slate-050;
    padding: $cs-space;
    color: $cs-slate-400;

    @media $display-breakpoints.md-and-up {
        padding: $cs-spaces.onehalf $cs-space;
    }
}

.content__partnerName {
    font-weight: 700;
    text-align: center;
    margin-bottom: 0;

    @media $display-breakpoints.md-and-up {
        margin-bottom: $cs-space;
    }
}

.content__description {
    margin-bottom: $cs-spaces.onehalf;
    display: none;

    @media $display-breakpoints.md-and-up {
        height: 120px;
        display: block;
    }
}

.content__link {
    color: $cs-slate-400;
    display: none;

    @media $display-breakpoints.md-and-up {
        display: inline-block;
    }
}
</style>
